import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface IInitialState {
  currentPrizeLoading: number | null;
}

const initialState: IInitialState = {
  currentPrizeLoading: null,
};

const prizeSlice = createSlice({
  name: 'prize',
  initialState,
  reducers: {
    setCurrentPrizeLoading(state, action: PayloadAction<number>) {
      state.currentPrizeLoading = action.payload;
    },
  },
});

export { prizeSlice };
